import { ArrowRight } from 'lucide-react';
import { Button, type ButtonProps } from '../../shadcdn/button.tsx';

/** A possible visitor reply, visually distinct from a business-action confirmation. */
export function SuggestedReply({ children, ...props }: Omit<ButtonProps, 'variant' | 'size'>) {
  return (
    <Button type="button" {...props} variant="suggestion" size="surface">
      <span className="min-w-0">{children}</span>
      <ArrowRight className="h-4 w-4 shrink-0" aria-hidden="true" />
    </Button>
  );
}
